import * as Tone from "tone";

const BIOMES: Record<string, { fundamental: number; type: OscillatorType; reverb: number }> = {
  Skinlands: { fundamental: 65.41, type: "sawtooth", reverb: 0.6 },
  Veinworks: { fundamental: 82.41, type: "square", reverb: 0.8 },
  "Bone Gardens": { fundamental: 110, type: "sine", reverb: 0.4 },
  "Neural Reach": { fundamental: 55, type: "triangle", reverb: 0.9 },
  Heartforge: { fundamental: 43.65, type: "sawtooth", reverb: 1 }
};

export class ResonanceEngine {
  private oscillators: Tone.Oscillator[] = [];
  private gain = new Tone.Gain(0.04).toDestination();
  private reverb = new Tone.Reverb({ decay: 4, wet: 0.6 }).connect(this.gain);

  async start(biome = "Skinlands") {
    await Tone.start();
    this.stop();
    const preset = BIOMES[biome] ?? BIOMES.Skinlands;
    this.reverb.wet.value = preset.reverb;
    this.oscillators = [1, 2, 3, 4].map((order) => {
      const osc = new Tone.Oscillator(preset.fundamental * order, preset.type).connect(this.reverb);
      osc.volume.value = -18 - order * 2;
      osc.start();
      return osc;
    });
  }

  setMomentum(momentum: number) {
    const shimmer = momentum >= 100 ? -8 : -18;
    for (const osc of this.oscillators) osc.volume.rampTo(shimmer, 0.2);
  }

  stop() {
    for (const osc of this.oscillators) osc.stop().dispose();
    this.oscillators = [];
  }
}
